import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { Auth0Provider } from "./auth/Auth0Provider";
import "./index.css";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";

const root = document.getElementById("root");
if (root === null) {
  throw new Error("Root element #root not found in index.html");
}
createRoot(root).render(
  <StrictMode>
    <Auth0Provider>
      <App />
    </Auth0Provider>
  </StrictMode>,
);
